import { SERVER_URL, SITE_URL } from 'config'

export function getClientURL() {
  return SITE_URL
}

export function getServerURL() {
  return SERVER_URL
}
